import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  minHeight: 530,
}));

export const Body = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 16,
}));

export const EmptyTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: 28,
  fontWeight: 700,
  lineHeight: "36px",
  color: colors.gray800,
}));

export const EmptySubTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: 16,
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  color: colors.gray600,
}));

export const EmptyDivButtons = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
  "& > button": {
    padding: "10px 20px 10px 16px",
  },
}));
